import {
  Box,
  Button,
  Grid,
  Paper,
  Typography,
  useTheme,
  useMediaQuery,
  Avatar,
} from "@mui/material";
import React from "react";

import userAnda from "../../assets/inmov-1.png";
import { useNavigate } from "react-router";
import { deepOrange } from "@mui/material/colors";

const StaticChat = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const navigate = useNavigate();

  const handleIntoBtn = () => {
    localStorage.setItem("chatPlaceholder", false);
    navigate("/dashboard");
  };

  return (
    <>
      <Box sx={{ paddingTop: "10px" }}>
        {/* chatbot text end */}
        <Grid container spacing={1} sx={{ paddingTop: "39px" }}>
          <Grid item xs={12} md={1}>
            <Box
              height={isSmallScreen ? "50%" : "80%"}
              width={"80%"}
              minWidth={"50px"}
            >
              <img
                src={userAnda}
                alt="user-anda"
                style={{ objectFit: "cover" }}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={10}
            sx={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Paper
              elevation={0}
              sx={{
                padding: "10px 20px 30px 10px",
                width: "94%",
                height: "84%",
                borderRadius: "10px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  sx={{
                    borderRadius: "50px",
                    width: "10px",
                    height: "10px",
                    background: "#1BEB29 0% 0% no-repeat padding-box",
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "16px",
                    color: "#8D8D8D",
                    fontFamily: "Poppins",
                    letterSpacing: 0,
                    paddingLeft: "10px",
                  }}
                >
                  INMOVATION AI
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "20px",
                  padding: "0 0 6px 19px",
                  fontFamily: "Poppins",
                  width: "100%",
                  letterSpacing: 0,
                }}
              >
                ¡Hola! Bienvenido a INMOVATION, tu asistente inteligente para
                vender más y mejor. Aquí puedes acceder fácilmente a casos de
                éxito, proyectos icónicos y documentos históricos relacionados
                con clientes y nuestra compañía. Puedes encontrar información
                usando lenguaje natural, como si estuvieras conversando conmigo,
                o utilizar filtros por categorías, subcategorías o temas clave.
                Ambas opciones están disponibles para que encuentres rápidamente
                lo que necesitas y cumplas tus objetivos comerciales.
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* user text end */}
        <Grid container spacing={2} sx={{ paddingTop: "39px" }}>
          <Grid
            item
            xs={12}
            md={10}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Paper
              elevation={0}
              sx={{
                backgroundColor: "#FF5722",
                color: "#FFFFFF",
                width: "78%",
                borderRadius: "10px",
                height: "90%",
              }}
            >
              <Box
                sx={{
                  paddingTop: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  height: "18px",
                }}
              >
                <Box
                  sx={{
                    borderRadius: "50px",
                    width: "10px",
                    height: "10px",
                    background: "#1BEB29 0% 0% no-repeat padding-box",
                  }}
                />
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    color: "#FFFFFF",
                    padding: "6px 15px 1px 10px",
                  }}
                >
                  USUARIO INMOV
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "20px",
                  padding: "6px 20px 20px 30px",
                  letterSpacing: 0,
                  width: "100%",
                }}
              >
                ¿Entonces puedo preguntar directamente o usar filtros?
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={1}>
            <Box
              height={isSmallScreen ? "50%" : "80%"}
              width={"80%"}
              minWidth={"50px"}
            >
              <Avatar
                src={localStorage.getItem("imageURL")}
                sx={{
                  bgcolor: deepOrange[500],
                  height: "59px",
                  width: "59px",
                }}
              >
                {localStorage.getItem("username").slice(0, 1)}
              </Avatar>
            </Box>
          </Grid>
        </Grid>

        {/* chatbot text end */}
        <Grid container spacing={1} sx={{ paddingTop: "39px" }}>
          <Grid item xs={12} md={1}>
            <Box
              height={isSmallScreen ? "50%" : "80%"}
              width={"80%"}
              minWidth={"50px"}
            >
              <img
                src={userAnda}
                alt="user-anda"
                style={{ objectFit: "cover" }}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={10}
            sx={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Paper
              elevation={0}
              sx={{
                padding: "10px 20px 30px 10px",
                width: "94%",
                height: "84%",
                borderRadius: "10px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  sx={{
                    borderRadius: "50px",
                    width: "10px",
                    height: "10px",
                    background: "#1BEB29 0% 0% no-repeat padding-box",
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "16px",
                    color: "#8D8D8D",
                    fontFamily: "Poppins",
                    letterSpacing: 0,
                    paddingLeft: "10px",
                  }}
                >
                  INMOVATION AI
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "20px",
                  padding: "0 0 6px 19px",
                  fontFamily: "Poppins",
                  width: "100%",
                  letterSpacing: 0,
                }}
              >
                ¡Exactamente! Usa lenguaje natural para hacer preguntas
                específicas o emplea nuestros filtros para explorar casos y
                proyectos organizados por categorías, subcategorías o temas
                clave.
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* user text  */}
        <Grid container spacing={2} sx={{ paddingTop: "39px" }}>
          <Grid
            item
            xs={12}
            md={10}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Paper
              elevation={0}
              sx={{
                backgroundColor: "#FF5722",
                color: "#FFFFFF",
                width: "55%",
                height: "90%",
                borderRadius: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <Box
                  sx={{
                    borderRadius: "50px",
                    width: "10px",
                    height: "10px",
                    background: "#1BEB29 0% 0% no-repeat padding-box",
                  }}
                />
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    color: "#FFFFFF",
                    padding: "6px 15px 0px 10px",
                  }}
                >
                  USUARIO INMOV
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "20px",
                  padding: "0px 20px 20px 30px",
                  letterSpacing: 0,
                  width: "100%",
                }}
              >
                ¡Genial! Suena fácil y eficiente.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={1}>
            <Box
              height={isSmallScreen ? "50%" : "80%"}
              width={"80%"}
              minWidth={"50px"}
            >
              <Avatar
                src={localStorage.getItem("imageURL")}
                sx={{
                  bgcolor: deepOrange[500],
                  height: "59px",
                  width: "59px",
                }}
              >
                {localStorage.getItem("username").slice(0, 1)}
              </Avatar>
            </Box>
          </Grid>
        </Grid>

        {/* chatbot text  */}
        <Grid container spacing={1} sx={{ paddingTop: "39px" }}>
          <Grid item xs={12} md={1}>
            <Box
              height={isSmallScreen ? "50%" : "80%"}
              width={"80%"}
              minWidth={"50px"}
            >
              <img
                src={userAnda}
                alt="user-anda"
                style={{ objectFit: "cover" }}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={10}
            sx={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Paper
              elevation={0}
              sx={{
                padding: "10px 20px 30px 10px",
                width: "94%",
                height: "84%",
                borderRadius: "10px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  sx={{
                    borderRadius: "50px",
                    width: "10px",
                    height: "10px",
                    background: "#1BEB29 0% 0% no-repeat padding-box",
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "16px",
                    color: "#8D8D8D",
                    fontFamily: "Poppins",
                    letterSpacing: 0,
                    paddingLeft: "10px",
                  }}
                >
                  INMOVATION AI
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "20px",
                  padding: "0 0 6px 19px",
                  fontFamily: "Poppins",
                  width: "100%",
                  letterSpacing: 0,
                }}
              >
                Esa es la idea: hacerlo simple, rápido y efectivo.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
        {/* user text end */}
        <Grid container spacing={2} sx={{ paddingTop: "39px" }}>
          <Grid
            item
            xs={12}
            md={10}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Paper
              elevation={0}
              sx={{
                backgroundColor: "#FF5722",
                color: "#FFFFFF",
                width: "55%",
                height: "90%",
                borderRadius: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <Box
                  sx={{
                    borderRadius: "50px",
                    width: "10px",
                    height: "10px",
                    background: "#1BEB29 0% 0% no-repeat padding-box",
                  }}
                />
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    color: "#FFFFFF",
                    padding: "6px 15px 0px 10px",
                  }}
                >
                  USUARIO INMOV
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "20px",
                  padding: "0px 20px 20px 30px",
                  letterSpacing: 0,
                  width: "100%",
                }}
              >
                ¡Perfecto, me queda muy claro!
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={1}>
            <Box
              height={isSmallScreen ? "50%" : "80%"}
              width={"80%"}
              minWidth={"50px"}
            >
              <Avatar
                src={localStorage.getItem("imageURL")}
                sx={{
                  bgcolor: deepOrange[500],
                  height: "59px",
                  width: "59px",
                }}
              >
                {localStorage.getItem("username").slice(0, 1)}
              </Avatar>
            </Box>
          </Grid>
        </Grid>
        {/* chatbot text end */}
        <Grid container spacing={1} sx={{ paddingTop: "39px" }}>
          <Grid item xs={12} md={1}>
            <Box
              height={isSmallScreen ? "50%" : "80%"}
              width={"80%"}
              minWidth={"50px"}
            >
              <img
                src={userAnda}
                alt="user-anda"
                style={{ objectFit: "cover" }}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={10}
            sx={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Paper
              elevation={0}
              sx={{
                padding: "10px 20px 30px 10px",
                width: "94%",
                height: "84%",
                borderRadius: "10px",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  sx={{
                    borderRadius: "50px",
                    width: "10px",
                    height: "10px",
                    background: "#1BEB29 0% 0% no-repeat padding-box",
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "16px",
                    color: "#8D8D8D",
                    fontFamily: "Poppins",
                    letterSpacing: 0,
                    paddingLeft: "10px",
                  }}
                >
                  INMOVATION AI
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "20px",
                  padding: "0 0 6px 19px",
                  fontFamily: "Poppins",
                  width: "100%",
                  letterSpacing: 0,
                }}
              >
                ¡Sigamos creando experiencias Phygital increíbles juntos!
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          paddingTop: "30px",
          paddingRight: "120px",
        }}
      >
        <Button
          size="large"
          variant="outlined"
          onClick={handleIntoBtn}
          sx={{
            textTransform: "uppercase",
            borderRadius: "30px",
            background: "#800080",
            color: "#fff",
            "&:hover": {
              background: "#800099",
              color: "#fff",
            },
          }}
        >
          OMITIR INTRODUCCIÓN
        </Button>
      </Box>
    </>
  );
};

export default StaticChat;
